import React from "react";

import { Banner, Research, Facts, Instructor } from "../components";

const Home = () => {
  return (
    <>
      <Banner />
      <Facts />
      <Research/>
      <Instructor />
    </>
  );
};

export default Home;
